import Vue from 'vue'
import qs from 'qs'
import axios from './plugins/axios'
import App from './App.vue'
import router from './router'
import './assets/js/global.js'
import './assets/css/global.css'
import './plugins/element.js' // 按需加载
import ElementUI from 'element-ui'
Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  axios,
  qs,
  render: h => h(App)
}).$mount('#app')
